import i18n from '@/utils/i18n';
import React from 'react';
import {
  Button,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';
import { Modal } from '@/experiences/sales-portal/components/modal';
import { Typography, XStack, YStack } from '@usepepper/sprout-kit-ui';

const MODAL_WIDTH = 400;

export interface ClearAllConfirmationModalProps {
  isOpen: boolean;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ClearAllConfirmationModal: React.FC<
  ClearAllConfirmationModalProps
> = ({ isOpen, loading, onCancel, onConfirm }) => {
  const [styles, theme] = useStyles();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      showCloseButton={false}
      width={MODAL_WIDTH}
    >
      <YStack gap={theme.sk.spacing.spaceMedium}>
        <Typography bold size="$md">
          {i18n.t('insights_hub.clear_confirmation_sheet.title')}
        </Typography>
        <Typography muted size="$md">
          {i18n.t('insights_hub.clear_confirmation_sheet.body')}
        </Typography>
        <XStack gap={theme.sk.spacing.spaceSmall} justifyContent="flex-end">
          <Button
            accessibilityLabel={i18n.t('cancel')}
            onPress={onCancel}
            style={styles.button}
            variant={ButtonVariant.Secondary}
          >
            {i18n.t('cancel')}
          </Button>
          <Button
            accessibilityLabel={i18n.t('clear')}
            loading={loading}
            onPress={onConfirm}
            style={styles.button}
            variant={ButtonVariant.Danger}
          >
            {i18n.t('clear')}
          </Button>
        </XStack>
      </YStack>
    </Modal>
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    paddingHorizontal: theme.sk.spacing.spaceLarge,
  },
}));
